import { render, staticRenderFns } from "./chart-profit.vue?vue&type=template&id=443cab15"
import script from "./chart-profit.vue?vue&type=script&lang=js"
export * from "./chart-profit.vue?vue&type=script&lang=js"
import style0 from "./chart-profit.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/stats/chart-profit.vue
// module id = QKxB
// module chunks = 0